import { ChevronRight, Landmark } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { overdueCount } from '../lib/installments';
import { useDebts } from '../lib/ledger';
import { IconSquare, ListGroup, listRowClass } from './ui/card';

/** The way in to Debts from Home and Accounts: one list group row, with the overdue badge. */
export function DebtsEntry() {
  const { t } = useTranslation();
  const debts = useDebts();
  const overdue = debts.data ? overdueCount(debts.data.items) : 0;
  return (
    <ListGroup>
      <li>
        <Link to="/debts" className={listRowClass}>
          <IconSquare>
            <Landmark aria-hidden="true" className="size-5" strokeWidth={2} />
          </IconSquare>
          <span className="flex min-w-0 flex-1 flex-col">
            <span className="text-[15px] font-medium">{t('debts.entry')}</span>
            <span className="truncate text-xs text-muted">{t('debts.entryHint')}</span>
          </span>
          {overdue > 0 && (
            <span className="shrink-0 rounded-full bg-surface-2 px-2.5 py-1 text-xs font-semibold text-expense">
              {t('debts.overdueBadge', { count: overdue })}
            </span>
          )}
          <ChevronRight aria-hidden="true" className="size-5 shrink-0 text-muted rtl:rotate-180" />
        </Link>
      </li>
    </ListGroup>
  );
}
